import React from 'react'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { BpButton } from '../../../shared/components/buttons/bp-button/BpButton'
import { IconBell } from '../../../shared/components/icons/IconBell'
import { useAppDispatch } from '../../../app/store/hooks/Redux'
import { useGetNotificationStateQuery } from '../../../app/api'
import { openAlertingSchedule } from '../alerting-schedule-modal/AlertingScheduleModal'
import {
  AlertType,
  scheduleLabel,
  scheduleTooltip,
} from '../alerting-schedule-modal/model/alerting'
import { useTimezones } from '../alerting-schedule-modal/model/useTimezones'
import styles from './AlertingChip.module.scss'

interface IAlertingChipProps {
  projectId?: number
  type: AlertType
}

/**
 * Чип уведомлений на экране нарушений: отвечает на вопрос «мне сейчас приходит». Тип выключен —
 * приглашение настроить, даже если расписание сохранено
 */
export const AlertingChip = ({ projectId, type }: IAlertingChipProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const timezones = useTimezones()
  const { data } = useGetNotificationStateQuery(
    { projectId: Number(projectId) },
    { skip: !projectId },
  )

  const settings = data?.data?.types[type]

  if (!projectId || !settings) return null

  const tooltip = settings.enabled
    ? scheduleTooltip(t, settings, timezones.label)
    : [t('components.alertingSchedule.noSchedule')]

  return (
    <Tooltip
      title={tooltip.map((line) => (
        <div key={line}>{line}</div>
      ))}
      placement={'topRight'}
    >
      <BpButton
        className={settings.enabled ? '' : styles.invite}
        iconLeft={<IconBell />}
        size={'sm'}
        theme={'outline'}
        type={'button'}
        onClick={() => dispatch(openAlertingSchedule(projectId, type))}
      >
        {settings.enabled
          ? scheduleLabel(t, settings)
          : t('components.alertingSchedule.setUpAlerts')}
      </BpButton>
    </Tooltip>
  )
}
